import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from '@core/constants';

@Pipe({
    name: 'dateFormatHTML',
    standalone: false
})
export class DateFormatHTMLPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (isNaN(Date.parse(value))) {
      return value;
    }
    return super.transform(value, Constants.DATE_FORMAT_HTML);
  }
}
